module.exports = __webpack_public_path__ + "media/images/company/company_04_01-dcacb83da065e3c0a2335ea1728a0472.jpg";